
export const SET_SYSTEMPARAMETERS = 'SET_SYSTEMPARAMETERS';

